import { gsap } from 'gsap';
import Flickity from 'flickity';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

import 'flickity-imagesloaded';
import 'flickity-bg-lazyload';
import 'flickity-fade';
import 'flickity-as-nav-for';
import { throttle } from 'lodash';

const MOS = {};
window.MOS = MOS;

(() => {
  const SCREENMDMAX = 1199;
  const HEADER_HEIGHT = 100;
  const TABLET_LANDSCAPE = 1024;
  const TABLET_PORTRAIT = 768;
  const SCREEN_SM_MAX = 767;
  const DEALER_SEARCH_STACK_MAX = 991;
  let winSize = 0;
  const calcWinSize = () => {
    winSize = { width: window.innerWidth, height: window.innerHeight };
  };

  const scrollTo = (elt, duration, target, offsetY) => {
    console.log('scrollto', elt, duration, target);
    gsap.to(
      window,
      {
        duration: duration || 1,
        scrollTo: (elt.getBoundingClientRect().top + window.scrollY) - (offsetY || 0),
        onComplete: () => {
          if (target !== undefined) {
            // window.location.hash = target;
          }
        },
      },
    );
  };

  const scrollToId = (href) => {
    if (href !== undefined) {
      const target = href.split('#')[1];
      if (document.getElementById(target) !== null) {
        scrollTo(document.getElementById(target), 1, target);
      }
    }
  };

  class AccordionMenuItem {
    constructor(elt, opts) {
      this.DOM = { elt };
      this.DOM.btn = this.DOM.elt.querySelector('.c-accordion-menu__btn');
      this.DOM.link = this.DOM.elt.querySelector('.c-accordion-menu__link');
      this.DOM.content = this.DOM.elt.querySelector('.c-accordion-menu__content');
      this.isOpen = this.DOM.elt.classList.contains('is-active');
      this.opts = opts;
    }
    toggleCurrent() {
      if (this.isOpen) {
        this.hide();
      } else {
        this.show();
      }
    }
    show() {
      this.toggle('SHOW');
      this.isOpen = true;
    }
    hide() {
      this.toggle('HIDE');
      this.isOpen = false;
    }
    toggle(action) {
      const self = this;
      if (action === 'SHOW') {
        gsap.to(self.DOM.content, { duration: 0.6, height: 'auto' });
        if (self.DOM.btn && self.opts.scrollTo === true) {
          scrollTo(self.DOM.btn, 1, null, HEADER_HEIGHT);
        }
        self.DOM.elt.classList.add('is-active');
      } else {
        gsap.to(self.DOM.content, {
          duration: 0.4,
          height: 0,
          onComplete: () => {
            self.DOM.elt.classList.remove('is-active');
          },
        });
      }
    }
  }
  class AccordionMenu {
    constructor(elt) {
      const self = this;
      self.DOM = { elt };
      self.settings = self.DOM.elt.hasAttribute('data-accordion') ? JSON.parse(self.DOM.elt.getAttribute('data-accordion')) : {};
      self.menuItems = [];
      Array.from(self.DOM.elt.querySelectorAll('.c-accordion-menu__item')).forEach(item => self.menuItems.push(new AccordionMenuItem(item, self.settings)));
      self.init();
      console.log('AccordioMenu::init', self.menuItems.length, self.settings);
    }

    init() {
      this.current = 0;
      this.initEvents();
      if (typeof this.settings !== 'undefined' && 'autoOpen' in this.settings) {
        this.showContent(this.settings.autoOpen);
      }
    }

    initEvents() {
      this.menuItems.forEach((item, pos) => {
        if (item.DOM.btn) {
          item.DOM.btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.showContent(pos);
          });
        }
        if (item.DOM.link) {
          item.DOM.link.addEventListener('click', (e) => {
            e.preventDefault();
            this.showContent(pos);
          });
        }
      });
    }

    showContent(pos) {
      console.log('POS', pos);
      if (typeof this.settings !== 'undefined' && 'autoClose' in this.settings) {
        if (this.current !== pos && this.menuItems[this.current].isOpen) {
          this.menuItems[this.current].hide();
        }
      }
      this.menuItems[pos].toggleCurrent();
      this.current = pos;
    }
  }

  class Tabs {
    constructor(elt) {
      this.DOM = { elt };
      this.DOM.tabList = this.DOM.elt.querySelector('.c-tabs__list');
      this.DOM.tabs = Array.from(this.DOM.elt.querySelectorAll('.c-tabs__tab'));
      this.DOM.panels = Array.from(this.DOM.elt.querySelectorAll('.c-tabs__panel'));
      this.current = 0;

      if (!this.DOM.tabList || this.DOM.tabs.length === 0 || this.DOM.panels.length === 0) {
        return;
      }

      this.init();
    }

    init() {
      // Determine initial active tab
      const initialIndex = this.DOM.tabs.findIndex(tab => tab.classList.contains('is-active'));
      this.current = initialIndex >= 0 ? initialIndex : 0;
      this.showTab(this.current, false);
      this.initEvents();
    }

    initEvents() {
      this.DOM.tabs.forEach((tab, index) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          this.showTab(index, true);
        });

        tab.addEventListener('keydown', (e) => {
          // Basic keyboard navigation: left/right arrows move focus between tabs
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            const dir = e.key === 'ArrowRight' ? 1 : -1;
            const nextIndex = (index + dir + this.DOM.tabs.length) % this.DOM.tabs.length;
            this.DOM.tabs[nextIndex].focus();
          }
        });
      });
    }

    showTab(index, updateFocus) {
      if (index < 0 || index >= this.DOM.tabs.length) return;

      this.DOM.tabs.forEach((tab, i) => {
        const isActive = i === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');

        const controlsId = tab.getAttribute('aria-controls');
        if (controlsId) {
          const panel = this.DOM.elt.querySelector(`#${controlsId}`);
          if (panel) {
            panel.classList.toggle('is-active', isActive);
            if (isActive) {
              panel.removeAttribute('hidden');
            } else {
              panel.setAttribute('hidden', 'hidden');
            }
          }
        }
      });

      this.current = index;

      if (updateFocus && this.DOM.tabs[index]) {
        this.DOM.tabs[index].focus();
      }
    }
  }

  class Carousels {
    constructor(element) {
      if (element.querySelector('.js-carousel')) {
        console.log('Carousels::init', element.querySelectorAll('.js-carousel').length);
        const self = this;
        self.settings = element.hasAttribute('data-settings') ? JSON.parse(element.getAttribute('data-settings')) : {};
        self.DOM = {
          elts: [],
          eltWrapper: element,
          progressBar: element.querySelector('.c-carousel-progressbar') ? element.querySelector('.c-carousel-progressbar') : undefined,
          count: element.querySelector('.js-carousel-count') ? element.querySelector('.js-carousel-count') : null,
          backgroundWrapper: element.closest('.c-hero-carousel') ? element.closest('.c-hero-carousel').querySelector('.c-hero-carousel__background-wrapper') : null,
        };
        element.querySelectorAll('.js-carousel').forEach((elt) => {
          self.DOM.elts.push(elt);
        });
        // Hero thumbs-nav can sit outside the wrapper as a sibling.
        const heroSection = element.closest('.c-hero-carousel');
        if (heroSection) {
          heroSection.querySelectorAll('.c-carousel__thumbs-nav.js-carousel').forEach((elt) => {
            if (!self.DOM.elts.includes(elt)) {
              self.DOM.elts.push(elt);
            }
          });
        }
        self.flcks = [];
        self.parallaxOffset = 0;
        self.init();
      }
    }
    init() {
      let idx = 0;
      const self = this;

      // Detect if this wrapper has a distinct "main" carousel.
      const hasMainCarousel = self.DOM.elts.some(elt => elt.classList.contains('c-carousel__main'));

      self.DOM.elts.forEach((instance) => {
        console.log('Carousels::init', idx);

        // Read options from data-flickity, if present
        let options = {};
        const attr = instance.getAttribute('data-flickity');
        if (attr) {
          try {
            options = JSON.parse(attr);
          } catch (e) {
            // fall back to Flickity's own parsing if JSON fails
            options = {};
          }
        }

        // Scope asNavFor to this wrapper so multiple carousels on one page
        // each sync with their own main (document.querySelector would always
        // hit the first .c-carousel__main). Prefer an #id in markup when
        // several mains share the page — Flickity htmlInit also reads data-flickity.
        let navTarget = null;
        if (typeof options.asNavFor === 'string') {
          navTarget = self.DOM.eltWrapper.querySelector(options.asNavFor)
            || document.querySelector(options.asNavFor)
            || (self.DOM.eltWrapper.closest('.c-hero-carousel')
              && self.DOM.eltWrapper.closest('.c-hero-carousel').querySelector(options.asNavFor));
          if (navTarget) {
            options.asNavFor = navTarget;
          }
        } else if (options.asNavFor) {
          navTarget = options.asNavFor;
        }

        // Fade + wrapAround interpolates through a wrap distance, which
        // briefly drives opacity through negative/overshot values (flicker).
        // Loop fade carousels with select(modulo) instead.
        if (options.fade === true && options.wrapAround === true) {
          options.wrapAround = false;
        }

        // Flickity htmlInit may already have created this instance with
        // wrapAround on. option() only mutates the object — destroy so
        // fade wrapping is not already baked into positioning.
        const existingFlck = Flickity.data(instance);
        if (existingFlck && options.fade && existingFlck.options.wrapAround) {
          existingFlck.destroy();
        }

        // Use explicit options if we successfully parsed any, otherwise
        // let Flickity read from data-flickity as before.
        const flck = Object.keys(options).length
          ? new Flickity(instance, options)
          : new Flickity(instance);

        // Flickity htmlInit may have already created this instance and bound
        // asNavFor to the first matching main. Rebind to the scoped target
        // after a tick so the companion carousel exists (same hack as as-nav-for).
        if (navTarget && typeof flck.setNavCompanion === 'function') {
          setTimeout(() => {
            if (flck.navCompanion) {
              flck.destroyAsNavFor();
            }
            flck.setNavCompanion(navTarget);
          });
        }

        // If this wrapper has a count element, drive it from the main carousel
        if (self.DOM.count && instance.classList.contains('c-carousel__main')) {
          self.totalSlides = flck.cells.length;
          flck.on('change', self.onChange.bind(self));
          self.onChange(0);
        }

        // Custom next/prev behaviour:
        // - If this wrapper has a distinct "main" carousel, attach the
        //   buttons only to that main instance (avoids double-nav on
        //   asNavFor thumbnail carousels, which causes flicker).
        // - If there is no "main" carousel, keep the original behaviour
        //   and attach to each instance.
        if (self.DOM.eltWrapper.querySelector('.btn--next')
          && self.DOM.eltWrapper.querySelector('.btn--prev')) {
          const shouldBindToThisInstance = hasMainCarousel
            ? instance.classList.contains('c-carousel__main')
            : true;

          if (shouldBindToThisInstance) {
            const nextBtn = self.DOM.eltWrapper.querySelector('.btn--next');
            const prevBtn = self.DOM.eltWrapper.querySelector('.btn--prev');

            // Bind once per button. CMS/Browser Link can run app init twice,
            // which would skip a slide (1→3) on a single click.
            if (nextBtn && !nextBtn.dataset.carouselNavBound) {
              nextBtn.dataset.carouselNavBound = 'true';
              nextBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const len = flck.slides.length;
                if (len < 2) {
                  return;
                }
                if (flck.options.fade) {
                  flck.select((flck.selectedIndex + 1) % len);
                } else {
                  flck.next();
                }
              });
            }

            if (prevBtn && !prevBtn.dataset.carouselNavBound) {
              prevBtn.dataset.carouselNavBound = 'true';
              prevBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const len = flck.slides.length;
                if (len < 2) {
                  return;
                }
                if (flck.options.fade) {
                  flck.select((flck.selectedIndex - 1 + len) % len);
                } else {
                  flck.previous();
                }
              });
            }
          }
        }

        if (self.DOM.progressBar !== undefined) {
          console.log(flck.slides.length);
          flck.slides.forEach(() => {
            const newDiv = document.createElement('div');
            newDiv.style.width = '50%';
            self.DOM.progressBar.appendChild(newDiv);
          });
          flck.on('change', self.onChange.bind(self));
          self.onChange(0);
        }

        if (self.DOM.eltWrapper.querySelector('.c-carousel__info')) {
          self.DOM.infoItem = self.DOM.eltWrapper.querySelector('.c-carousel__info');
          self.DOM.infoItems = self.DOM.eltWrapper.querySelectorAll('.c-carousel__info-item');
          self.DOM.closeBtn = self.DOM.eltWrapper.querySelector('.btn-close');
          flck.on('change', self.onChange.bind(self));
          self.DOM.closeBtn.addEventListener('click', self.onClose.bind(self));
          self.isInfoClosed = false;
          if (winSize.width <= SCREENMDMAX) {
            self.onClose();
          }
        }

        // Add parallax effect for hero carousel background (main carousel only)
        const shouldBindParallax = self.settings.animateBackground === true
          && self.DOM.backgroundWrapper
          && (hasMainCarousel ? instance.classList.contains('c-carousel__main') : true);
        if (shouldBindParallax) {
          console.log('animateBackground', self.settings.animateBackground);
          self.parallaxFlck = flck;
          flck.on('scroll', self.onParallaxScroll.bind(self));
          flck.on('settle', self.onParallaxSettle.bind(self));
        }

        const shouldInitBottomCenterNav = self.DOM.eltWrapper.closest('.c-hero-carousel[data-nav-position="bottom-center"]')
          && self.DOM.eltWrapper.querySelector('.c-hero-carousel__nav--prev')
          && self.DOM.eltWrapper.querySelector('.c-hero-carousel__nav--next')
          && (hasMainCarousel ? instance.classList.contains('c-carousel__main') : true);

        if (shouldInitBottomCenterNav) {
          self.initBottomCenterNav(instance);
        }

        self.flcks.push(flck);
        idx += 1;
      });

      // Pause main autoplay when the user clicks a thumbs-nav button.
      const mainIndex = self.DOM.elts.findIndex(elt => elt.classList.contains('c-carousel__main'));
      const thumbsIndex = self.DOM.elts.findIndex(elt => elt.classList.contains('c-carousel__thumbs-nav'));
      if (mainIndex >= 0 && thumbsIndex >= 0) {
        const mainFlck = self.flcks[mainIndex];
        const thumbsElt = self.DOM.elts[thumbsIndex];
        thumbsElt.addEventListener('click', (e) => {
          if (e.target.closest('button, .btn')) {
            mainFlck.stopPlayer();
          }
        });
      }

      // Team carousel: main cells stack before Flickity measures viewport height.
      if (self.DOM.eltWrapper.classList.contains('c-team-carousel')) {
        const mainIndex = self.DOM.elts.findIndex(elt => elt.classList.contains('c-carousel__main'));
        const mainFlck = mainIndex >= 0 ? self.flcks[mainIndex] : null;

        if (mainFlck) {
          const fixMainHeight = () => {
            mainFlck.resize();
            console.log('Team carousel: main cells are now visible');
          };

          mainFlck.on('ready', fixMainHeight);
          requestAnimationFrame(() => requestAnimationFrame(fixMainHeight));

          if (document.readyState === 'complete') {
            fixMainHeight();
          } else {
            window.addEventListener('load', fixMainHeight, { once: true });
          }
        }
      }
    }
    onChange(idx) {
      const self = this;
      if (self.DOM.infoItem) {
        console.log('info', this.DOM.infoItem, this.DOM.infoItems, 'total:', self.totalSlides);
        self.DOM.infoItems.forEach((elt, index) => {
          if (index === idx) {
            elt.classList.add('is-active');
          } else {
            elt.classList.remove('is-active');
          }
        });
      }

      if (self.DOM.progressBar) {
        const currIdx = idx + 1;
        self.DOM.progressBar.querySelectorAll('div').forEach((elt) => {
          elt.classList.remove('is-active');
        });
        self.DOM.progressBar.querySelector(`:nth-child(${currIdx})`).classList.add('is-active');
      }

      if (self.DOM.count && typeof self.totalSlides === 'number' && self.totalSlides > 0) {
        const current = idx + 1;
        const total = self.totalSlides;
        const format = n => (n < 10 ? `0${n}` : String(n));
        self.DOM.count.textContent = `${format(current)} / ${format(total)}`;
      }
    }

    onClose() {
      const self = this;
      if (self.isInfoClosed) {
        self.DOM.infoItem.classList.add('is-opened');
        self.isInfoClosed = false;
      } else {
        self.DOM.infoItem.classList.remove('is-opened');
        self.isInfoClosed = true;
      }
    }

    initBottomCenterNav(instance) {
      const self = this;
      const prevBtn = self.DOM.eltWrapper.querySelector('.c-hero-carousel__nav--prev');
      const nextBtn = self.DOM.eltWrapper.querySelector('.c-hero-carousel__nav--next');
      const pageDots = instance.querySelector('.flickity-page-dots');

      if (!prevBtn || !nextBtn || !pageDots) {
        return;
      }

      let navControls = self.DOM.eltWrapper.querySelector('.c-hero-carousel__nav-controls');
      if (!navControls) {
        navControls = document.createElement('div');
        navControls.className = 'c-hero-carousel__nav-controls';
        self.DOM.eltWrapper.appendChild(navControls);
      }

      navControls.appendChild(prevBtn);
      navControls.appendChild(pageDots);
      navControls.appendChild(nextBtn);
    }

    getParallaxOffset(progress) {
      const parallaxFactor = this.settings.parallaxFactor !== undefined ?
        this.settings.parallaxFactor : 0.2;
      const moveAmount = progress * 100 * parallaxFactor;
      // Create infinite loop by using modulo 33.333 (one full background width)
      return moveAmount % 33.333;
    }

    getParallaxProgress(index) {
      const flck = this.parallaxFlck;
      if (!flck || flck.slides.length <= 1) {
        return 0;
      }
      // Match Flickity scroll progress: positionX / slidesWidth
      return index / (flck.slides.length - 1);
    }

    onParallaxScroll(progress) {
      const self = this;
      if (!self.DOM.backgroundWrapper) return;
      gsap.killTweensOf(self.DOM.backgroundWrapper);
      const loopedAmount = self.getParallaxOffset(progress);
      gsap.set(self.DOM.backgroundWrapper, {
        x: `${-loopedAmount}%`,
      });
    }

    onParallaxSettle(index) {
      const self = this;
      if (!self.DOM.backgroundWrapper) return;
      gsap.killTweensOf(self.DOM.backgroundWrapper);
      const loopedAmount = self.getParallaxOffset(self.getParallaxProgress(index));
      // Snap to final position; scroll handler already tracks during transition
      gsap.set(self.DOM.backgroundWrapper, {
        x: `${-loopedAmount}%`,
      });
    }
  }
  class DDMenuItem {
    constructor(elt) {
      this.DOM = { elt };
      this.DOM.link = this.DOM.elt.querySelector('.c-main-nav__link');
      this.DOM.content = this.DOM.elt.querySelector('.c-main-nav__menu-item-level');
      this.isOpen = this.DOM.elt.classList.contains('is-active');
      this.init();
    }

    init() {
      const self = this;
      if (!self.DOM.link || !self.DOM.content) {
        return;
      }
      self.DOM.link.addEventListener('click', self.onLinkClick.bind(self));
    }

    onLinkClick(e) {
      if (winSize.width > SCREENMDMAX) {
        return;
      }
      e.preventDefault();
      this.toggleCurrent();
    }

    toggleCurrent() {
      if (this.isOpen) {
        this.hide();
      } else {
        this.show();
      }
    }
    show() {
      this.toggle('SHOW');
      this.isOpen = true;
    }
    hide() {
      this.toggle('HIDE');
      this.isOpen = false;
    }
    toggle(action) {
      if (action === 'SHOW') {
        gsap.to(this.DOM.content, { height: 'auto', duration: 0.3 });
        this.DOM.elt.classList.add('is-active');
      } else {
        gsap.to(this.DOM.content, { height: 0, duration: 0.3 });
        this.DOM.elt.classList.remove('is-active');
      }
    }
  }
  class SideNav {
    constructor(elt, eltWrapper) {
      if (document.querySelector(elt) && document.querySelector(eltWrapper)) {
        const self = this;
        self.DOM = { elt: document.querySelector(elt) };
        self.DOM.eltWrapper = document.querySelector(eltWrapper);
        self.settings = self.DOM.elt.hasAttribute('data-settings') ? JSON.parse(self.DOM.elt.getAttribute('data-settings')) : {};
        self.DOM.openBtn = self.DOM.eltWrapper.querySelector('.btn-burger');
        self.DOM.closeBtn = self.DOM.eltWrapper.querySelector('.btn-close');
        self.isOpen = false;
        self.initEvents();
      }
    }
    initEvents() {
      console.log('SideNav::initEvents');
      const self = this;
      self.DOM.openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.isOpen) {
          this.toggle('close');
        } else {
          this.toggle('open');
        }
      });
      self.DOM.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggle('close');
      });
      self.menuItems = [];
      Array.from(self.DOM.elt.querySelectorAll('.menu__item--ddm')).forEach(item => this.menuItems.push(new DDMenuItem(item)));
    }

    toggle(action, _self) {
      const self = _self || this;
      self.isOpen = action === 'open';

      if (self.isOpen) {
        self.DOM.elt.classList.add('is-open');
        self.DOM.openBtn.classList.add('is-active');
      } else {
        self.DOM.elt.classList.remove('is-open');
        self.DOM.openBtn.classList.remove('is-active');
      }
    }
  }
  class MainNav {
    constructor(elt, eltWrapper) {
      const self = this;
      if (document.querySelector(elt) && document.querySelector(eltWrapper)) {
        self.DOM = { elt: document.querySelector(elt) };
        self.DOM.eltWrapper = document.querySelector(eltWrapper);
        self.settings = self.DOM.elt.hasAttribute('data-settings') ? JSON.parse(self.DOM.elt.getAttribute('data-settings')) : {};
        self.DOM.toggleBtn = document.querySelector('.btn-burger');
        self.DOM.closeBtn = self.DOM.eltWrapper.querySelector('.btn-close');
        self.isOpen = false;
        self.initEvents();
      }
    }

    initEvents() {
      console.log('MainNav::initEvents');
      const self = this;
      self.DOM.toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (self.isOpen) {
          self.toggle('close');
          document.querySelector('body').classList.remove('is-open');
        } else {
          self.toggle('open');
          document.querySelector('body').classList.add('is-open');
        }
      });

      if (self.DOM.closeBtn) {
        self.DOM.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggle('close');
        });
      }

      self.menuItems = [];
      Array.from(self.DOM.elt.querySelectorAll('.menu__item--ddm')).forEach(item => this.menuItems.push(new DDMenuItem(item)));

      if (self.settings.sticky !== undefined && self.settings.sticky
        && winSize.width > SCREENMDMAX) {
        window.addEventListener('scroll', throttle(self.onScroll.bind(self), 500, { leading: true, trailing: true }));
      }
    }

    open() {
      this.DOM.elt.classList.add('is-open');
      this.DOM.toggleBtn.classList.add('is-active');
      this.isOpen = true;
    }

    close() {
      this.DOM.elt.classList.remove('is-open');
      this.DOM.toggleBtn.classList.remove('is-active');
      this.isOpen = false;
    }

    toggle(action, _self) {
      const self = _self || this;
      self.isOpen = action === 'open';

      if (self.isOpen) {
        self.open();
      } else {
        self.close();
      }
    }

    onScroll() {
      const windowScrollY = window.scrollY;
      if (windowScrollY > 50) {
        this.DOM.elt.classList.add('is-sticky');
        this.DOM.isSticky = true;
      } else {
        this.DOM.elt.classList.remove('is-sticky');
        this.DOM.isSticky = false;
      }
      // console.log('StickyNav::scrolling', windowScrollY);
    }
  }
  class MegaMenu {
    constructor() {
      const self = this;
      self.DOM = {
        triggers: document.querySelectorAll('[data-mega-menu]'),
        menus: document.querySelectorAll('.c-mega-menu'),
        closeBtns: document.querySelectorAll('.c-mega-menu__close'),
      };
      self.activeMenu = null;
      if (self.DOM.triggers.length > 0) {
        self.initEvents();
      }
    }

    initEvents() {
      const self = this;
      // Handle trigger clicks
      self.DOM.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const menuId = trigger.getAttribute('data-mega-menu');
          self.toggleMenu(menuId, trigger);
        });
      });

      // Handle close button clicks
      self.DOM.closeBtns.forEach((closeBtn) => {
        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          self.closeAllMenus();
        });
      });

      // Close menu when clicking outside
      document.addEventListener('click', (e) => {
        if (self.activeMenu) {
          const menu = document.getElementById(`mega-menu-${self.activeMenu}`);
          const trigger = document.querySelector(`[data-mega-menu="${self.activeMenu}"]`);
          if (menu && !menu.contains(e.target) && trigger && !trigger.contains(e.target)) {
            self.closeAllMenus();
          }
        }
      });

      // Close menu on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && self.activeMenu) {
          self.closeAllMenus();
        }
      });
    }

    toggleMenu(menuId, trigger) {
      const self = this;
      const menu = document.getElementById(`mega-menu-${menuId}`);
      if (!menu) return;

      // If clicking the same menu, close it
      if (self.activeMenu === menuId) {
        self.closeAllMenus();
        return;
      }

      // Close any open menus first
      self.closeAllMenus();

      // Open the selected menu
      self.activeMenu = menuId;
      menu.setAttribute('aria-hidden', 'false');
      menu.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      trigger.classList.add('is-active');
      document.body.classList.add('c-mega-menu-open');

      // Animate menu opening
      gsap.fromTo(
        menu, {
          opacity: 0,
          y: -20,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.3,
          ease: 'power2.out',
        },
      );
    }

    closeAllMenus() {
      const self = this;
      if (!self.activeMenu) return;

      const menu = document.getElementById(`mega-menu-${self.activeMenu}`);
      const trigger = document.querySelector(`[data-mega-menu="${self.activeMenu}"]`);

      if (menu) {
        menu.setAttribute('aria-hidden', 'true');
        menu.classList.remove('is-open');
        gsap.to(menu, {
          opacity: 0,
          y: -20,
          duration: 0.2,
          ease: 'power2.in',
          onComplete: () => {
            menu.style.display = '';
          },
        });
      }

      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.classList.remove('is-active');
      }

      document.body.classList.remove('c-mega-menu-open');
      self.activeMenu = null;
    }
  }

  class Header {
    constructor(elt) {
      const self = this;
      if (document.querySelector(elt)) {
        self.DOM = { elt: document.querySelector(elt) };
        self.settings = self.DOM.elt.hasAttribute('data-settings') ? JSON.parse(self.DOM.elt.getAttribute('data-settings')) : {};
        self.initEvents();
      }
    }

    initEvents() {
      console.log('Header::initEvents');
      const self = this;
      window.addEventListener('scroll', throttle(self.onScroll.bind(self), 500, { leading: true, trailing: true }));
    }

    onScroll() {
      const windowScrollY = window.scrollY;
      if (windowScrollY > 50) {
        this.DOM.elt.classList.add('is-sticky');
        this.DOM.isSticky = true;
      } else {
        this.DOM.elt.classList.remove('is-sticky');
        this.DOM.isSticky = false;
      }
      // console.log('StickyNav::scrolling', windowScrollY);
    }
  }
  class Videos {
    constructor(elt) {
      this.DOM = { elt };
      this.initEvents();
    }

    initEvents() {
      const self = this;
      const videoEl = self.DOM.elt.querySelector('video');
      const btn = self.DOM.elt.querySelector('.video-play-overlay');
      btn.addEventListener('click', () => {
        videoEl.play().catch(err => console.warn(err));
      });

      // Hide overlay once video actually plays
      videoEl.addEventListener('play', () => {
        btn.classList.add('hidden');
      });

      // When paused, show the overlay again
      videoEl.addEventListener('pause', () => {
        btn.classList.remove('hidden');
      });

      // When video ends, reset to replay
      videoEl.addEventListener('ended', () => {
        btn.classList.remove('hidden');
      });

      function startOnClickOnce() {
        videoEl.play().catch(err => console.warn(err));
        videoEl.removeEventListener('click', startOnClickOnce);
      }

      videoEl.addEventListener('click', startOnClickOnce);
    }
  }

  class HeroStickyNav {
    constructor(heroSelector, navSelector) {
      const self = this;
      self.DOM = {};
      self.DOM.hero = document.querySelector(heroSelector);
      self.DOM.nav = document.querySelector(navSelector);

      if (!self.DOM.hero || !self.DOM.nav) return;

      self.heroHeight = 0;
      self.heroBottom = 0;

      self.updateHeroDimensions();
      window.addEventListener('resize', throttle(() => {
        self.updateHeroDimensions();
      }, 250));

      window.addEventListener('scroll', throttle(self.onScroll.bind(self), 100, { leading: true, trailing: true }));
      self.onScroll(); // Initial check
    }

    updateHeroDimensions() {
      if (this.DOM.hero) {
        const rect = this.DOM.hero.getBoundingClientRect();
        this.heroHeight = rect.height;
        this.heroBottom = rect.bottom + window.scrollY;
      }
    }

    onScroll() {
      const windowScrollY = window.scrollY;
      const heroRect = this.DOM.hero.getBoundingClientRect();
      const heroBottom = heroRect.bottom + windowScrollY;
      // Check if scrolled past hero viewport
      if (windowScrollY > heroBottom) {
        this.DOM.nav.classList.add('is-collapsed');
        this.DOM.hero.classList.add('is-scrolled-past');
      } else {
        this.DOM.nav.classList.remove('is-collapsed');
        this.DOM.hero.classList.remove('is-scrolled-past');
      }
    }
  }

  class FormPopup {
    constructor(elt) {
      this.DOM = {
        elt: document.querySelector(elt),
        openBtn: document.querySelector('#btn-request-callback'),
        openBtnMobile: document.querySelector('#btn-request-callback-mobile'),
      };

      if (!this.DOM.elt || !this.DOM.openBtn) return;

      this.DOM.closeBtn = this.DOM.elt.querySelector('.c-form-popup__close');
      this.DOM.firstField = this.DOM.elt.querySelector('input, select, button, a[href]');
      this.animationFrame = null;
      this.closeTimer = null;
      this.isOpen = false;
      this.initEvents();
    }

    initEvents() {
      this.DOM.openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });

      this.DOM.openBtnMobile.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });

      if (this.DOM.closeBtn) {
        this.DOM.closeBtn.addEventListener('click', () => this.close());
      }

      this.DOM.elt.addEventListener('click', (e) => {
        if (e.target === this.DOM.elt) this.close();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) this.close();
      });
    }

    open() {
      window.clearTimeout(this.closeTimer);
      window.cancelAnimationFrame(this.animationFrame);
      this.DOM.elt.hidden = false;
      this.DOM.elt.scrollLeft = 0;
      this.DOM.openBtn.setAttribute('aria-expanded', 'true');
      this.isOpen = true;

      this.animationFrame = window.requestAnimationFrame(() => {
        this.DOM.elt.classList.add('is-open');
        if (this.DOM.firstField) this.DOM.firstField.focus({ preventScroll: true });
      });
    }

    close() {
      window.cancelAnimationFrame(this.animationFrame);
      this.DOM.elt.classList.remove('is-open');
      this.DOM.openBtn.setAttribute('aria-expanded', 'false');
      this.isOpen = false;
      this.DOM.openBtn.focus();

      this.closeTimer = window.setTimeout(() => {
        if (this.isOpen) return;
        this.DOM.elt.hidden = true;
      }, 300);
    }
  }

  class SearchModal {
    constructor(elt) {
      const self = this;
      if (document.querySelector(elt)) {
        self.DOM = { elt: document.querySelector(elt) };
        self.DOM.openBtn = document.querySelector('#btn-search');
        self.DOM.closeBtn = self.DOM.elt.querySelector('.c-search-modal__close');
        self.isOpen = self.DOM.elt.classList.contains('is-open');
        self.initEvents();
      }
    }

    initEvents() {
      console.log('SearchModal::initEvents');
      const self = this;

      if (self.DOM.openBtn) {
        self.DOM.openBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (self.isOpen) {
            self.toggle('close');
          } else {
            self.toggle('open');
          }
        });
      }

      if (self.DOM.closeBtn) {
        self.DOM.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          self.toggle('close');
        });
      }

      // Close on Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && self.isOpen) {
          self.toggle('close');
        }
      });

      // Handle checkbox interactions
      const allPagesCheckbox = self.DOM.elt.querySelector('#pages-all');
      const filterCheckboxes = self.DOM.elt.querySelectorAll('.c-search-modal__filters input[type="checkbox"]:not(#pages-all)');

      if (allPagesCheckbox && filterCheckboxes.length > 0) {
        // Helper function to check if all filter checkboxes are unchecked
        const checkIfAllUnchecked = () => {
          const allUnchecked = Array.from(filterCheckboxes).every(checkbox => !checkbox.checked);
          if (allUnchecked && !allPagesCheckbox.checked) {
            allPagesCheckbox.checked = true;
          }
        };

        // When any filter checkbox is checked, uncheck "All Pages"
        // When any filter checkbox is unchecked, check if all are unchecked
        filterCheckboxes.forEach((checkbox) => {
          checkbox.addEventListener('change', (e) => {
            if (e.target.checked && allPagesCheckbox.checked) {
              allPagesCheckbox.checked = false;
            } else if (!e.target.checked) {
              checkIfAllUnchecked();
            }
          });
        });

        // When "All Pages" is checked, uncheck all other filters
        allPagesCheckbox.addEventListener('change', (e) => {
          if (e.target.checked) {
            filterCheckboxes.forEach((checkbox) => {
              checkbox.checked = false;
            });
          }
        });
      }
    }

    open() {
      this.DOM.elt.classList.add('is-open');
      this.isOpen = true;
      document.querySelector('body').classList.add('c-search-modal--is-open');
    }

    close() {
      this.DOM.elt.classList.remove('is-open');
      this.isOpen = false;
      document.querySelector('body').classList.remove('c-search-modal--is-open');
    }

    toggle(action) {
      if (action === 'open') {
        this.open();
      } else {
        this.close();
      }
    }
  }

  class SearchResultsFilter {
    constructor(elt) {
      const self = this;
      self.DOM = { elt: document.querySelector(elt) };
      this.initEvents();
    }
    initEvents() {
      console.log('SearchResultsFilter::initEvents');
      const self = this;
      // Handle checkbox interactions
      const allPagesCheckbox = self.DOM.elt.querySelector('#pages-all');
      const filterCheckboxes = self.DOM.elt.querySelectorAll('.c-search-modal__filters input[type="checkbox"]:not(#pages-all)');

      if (allPagesCheckbox && filterCheckboxes.length > 0) {
        // Helper function to check if all filter checkboxes are unchecked
        const checkIfAllUnchecked = () => {
          const allUnchecked = Array.from(filterCheckboxes).every(checkbox => !checkbox.checked);
          if (allUnchecked && !allPagesCheckbox.checked) {
            allPagesCheckbox.checked = true;
          }
        };

        // When any filter checkbox is checked, uncheck "All Pages"
        // When any filter checkbox is unchecked, check if all are unchecked
        filterCheckboxes.forEach((checkbox) => {
          checkbox.addEventListener('change', (e) => {
            if (e.target.checked && allPagesCheckbox.checked) {
              allPagesCheckbox.checked = false;
            } else if (!e.target.checked) {
              checkIfAllUnchecked();
            }
          });
        });

        // When "All Pages" is checked, uncheck all other filters
        allPagesCheckbox.addEventListener('change', (e) => {
          if (e.target.checked) {
            filterCheckboxes.forEach((checkbox) => {
              checkbox.checked = false;
            });
          }
        });
      }
    }
  }

  // ---------------------------------------------------------------------------
  // Dealer Search
  // ---------------------------------------------------------------------------

  class DealerSearch {
    constructor(elt) {
      const self = this;
      self.DOM = { elt };
      self.DOM.mapEl = elt.querySelector('#dealer-search-map');
      self.DOM.mapWrap = elt.querySelector('.c-dealer-search__map-wrap');
      self.DOM.mapConsent = elt.querySelector('.c-dealer-search__map-consent');
      self.DOM.mapConsentBtn = elt.querySelector('.c-dealer-search__map-consent-btn');
      self.DOM.form = elt.querySelector('.c-dealer-search__form');
      self.DOM.locationInput = elt.querySelector('#dealer-location');
      self.DOM.radiusSelect = elt.querySelector('#dealer-radius');
      self.DOM.resultsList = elt.querySelector('.c-dealer-search__results');
      self.DOM.countEl = elt.querySelector('.c-dealer-search__count');
      self.DOM.mapPanel = elt.querySelector('.c-dealer-search__map-panel');
      self.DOM.mapPanelBody = elt.querySelector('.c-dealer-search__map-panel-body');
      self.DOM.mapPanelClose = elt.querySelector('.c-dealer-search__map-panel-close');
      self.DOM.panelStatus = elt.querySelector('.c-dealer-search__panel-status');
      self.DOM.callbackTrigger = elt.querySelector('.c-dealer-search__callback-trigger');
      self.DOM.callbackPanel = elt.querySelector('.c-dealer-search__callback-panel');
      self.DOM.callbackClose = elt.querySelector('.c-dealer-search__callback-close');
      self.DOM.locateBtn = elt.querySelector('.c-dealer-search__locate-btn');

      const dataEl = elt.querySelector('.c-dealer-search__data');
      self.allDealers = dataEl ? JSON.parse(dataEl.textContent) : [];
      self.visibleDealers = self.allDealers.slice();
      self.map = null;
      self.markers = [];
      self.geocoder = null;
      self.placesAutocomplete = null;
      self.PlaceAutocompleteElement = null;
      self.selectedLocation = null;
      self.Route = null;
      self.RouteMatrix = null;
      self.routePolylines = [];
      self.routeAnimationFrame = null;
      self.activeRouteItemId = null;
      self.mapsLoadStarted = false;
      self.consentListenersBound = false;
      self.apiKey = elt.dataset.googleMapsKey || '';
      self.mapSettings = elt.dataset.settings ? JSON.parse(elt.dataset.settings) : {};
      self.autoCompleteEnabled = self.mapSettings.autoComplete === true;
      self.routeAnimationEnabled = self.mapSettings.routeAnimation === true;
      self.useGeolocationEnabled = self.mapSettings.useGeolocation === true;

      if (!self.useGeolocationEnabled && self.DOM.locateBtn) {
        self.DOM.locateBtn.hidden = true;
      }

      self.renderResults(self.visibleDealers);
      self.initEvents();

      if (self.DOM.mapEl) {
        if (self.apiKey) {
          self.initMapConsentGate();
        } else {
          self.initMapFallback();
        }
      }
    }

    // Returns true / false when Cookiebot consent is known, or null while unknown.
    // Cookiebot docs use a truthy check (`if (Cookiebot.consent.marketing)`), not === true.
    static hasMarketingConsent() {
      if (typeof window.Cookiebot === 'undefined') return null;
      if (!window.Cookiebot.consent) return null;
      return !!window.Cookiebot.consent.marketing;
    }

    initMapConsentGate() {
      this.bindMapConsentListeners();

      if (DealerSearch.hasMarketingConsent()) {
        this.hideMapConsentPlaceholder();
        this.loadGoogleMaps();
        return;
      }

      // Wait for Cookiebot, or fall back for static prototypes without CMP.
      this.showMapConsentPlaceholder();
      window.setTimeout(() => {
        if (this.mapsLoadStarted) return;

        if (DealerSearch.hasMarketingConsent()) {
          this.hideMapConsentPlaceholder();
          this.loadGoogleMaps();
          return;
        }

        // No Cookiebot on this page (e.g. local HTML prototype) — allow Maps.
        if (typeof window.Cookiebot === 'undefined') {
          this.hideMapConsentPlaceholder();
          this.loadGoogleMaps();
        }
      }, 2000);
    }

    showMapConsentPlaceholder() {
      if (this.DOM.mapConsent) this.DOM.mapConsent.hidden = false;
      if (this.DOM.mapEl) this.DOM.mapEl.setAttribute('aria-hidden', 'true');
    }

    hideMapConsentPlaceholder() {
      if (this.DOM.mapConsent) this.DOM.mapConsent.hidden = true;
      if (this.DOM.mapEl) this.DOM.mapEl.removeAttribute('aria-hidden');
    }

    tryLoadMapAfterConsent() {
      if (this.mapsLoadStarted) return;
      // Consent / auto-blocker state can update slightly after the event.
      const attempt = (delay) => {
        window.setTimeout(() => {
          if (this.mapsLoadStarted) return;
          if (!DealerSearch.hasMarketingConsent()) return;
          this.hideMapConsentPlaceholder();
          this.loadGoogleMaps();
        }, delay);
      };
      attempt(50);
      attempt(300);
      attempt(1000);
    }

    openCookiebotDialog() {
      if (!window.Cookiebot) return;
      // renew() is the documented way to change consent; show() is a fallback.
      if (typeof window.Cookiebot.renew === 'function') {
        window.Cookiebot.renew();
      } else if (typeof window.Cookiebot.show === 'function') {
        window.Cookiebot.show();
      }
    }

    bindMapConsentListeners() {
      if (this.consentListenersBound) return;
      this.consentListenersBound = true;

      const onConsentChange = () => this.tryLoadMapAfterConsent();

      window.addEventListener('CookiebotOnConsentReady', onConsentChange);
      window.addEventListener('CookiebotOnAccept', onConsentChange);
      window.addEventListener('CookiebotOnAcceptAll', onConsentChange);
      window.addEventListener('CookiebotOnDialogHide', onConsentChange);
      window.addEventListener('CookiebotOnDecline', () => {
        window.setTimeout(() => {
          if (!DealerSearch.hasMarketingConsent()) {
            this.showMapConsentPlaceholder();
          }
        }, 50);
      });

      // Callbacks fire even if the matching window event was missed (timing).
      const prevOnAccept = window.CookiebotCallback_OnAccept;
      window.CookiebotCallback_OnAccept = () => {
        if (typeof prevOnAccept === 'function') prevOnAccept();
        onConsentChange();
      };

      if (this.DOM.mapConsentBtn) {
        this.DOM.mapConsentBtn.addEventListener('click', () => this.openCookiebotDialog());
      }
    }

    loadGoogleMaps() {
      if (this.mapsLoadStarted || !this.apiKey) return;

      // Block when Cookiebot is present and marketing is not accepted.
      if (typeof window.Cookiebot !== 'undefined' && !DealerSearch.hasMarketingConsent()) {
        this.showMapConsentPlaceholder();
        this.bindMapConsentListeners();
        return;
      }

      this.mapsLoadStarted = true;
      this.hideMapConsentPlaceholder();

      // Avoid double-loading if a previous (blocked) attempt already left a tag.
      if (document.querySelector('script[data-dealer-search-maps="1"]')) {
        if (window.google && google.maps && typeof google.maps.importLibrary === 'function') {
          this.initMap();
        }
        return;
      }

      window.dealerSearchMapReady = () => {
        this.initMap();
      };

      // With loading=async, libraries are loaded via importLibrary() in initMap —
      // do not pass libraries= here (it conflicts with the dynamic loader).
      const mapsSrc = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&v=weekly&loading=async&callback=dealerSearchMapReady`;

      const script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.dataset.dealerSearchMaps = '1';
      // We already gated on marketing consent. Ignore auto-blocking so Cookiebot
      // does not rewrite this into text/plain (that breaks Google's module loader).
      script.setAttribute('data-cookieconsent', 'ignore');
      script.src = mapsSrc;
      document.head.appendChild(script);
    }

    initMapFallback() {
      if (this.DOM.mapEl) {
        this.DOM.mapEl.style.background = '#E1E4EA';
        this.DOM.mapEl.innerHTML = '<p style="padding:20px;color:#848E9A;font-size:0.875rem;">Map requires a Google Maps API key.</p>';
      }
      this.hideMapConsentPlaceholder();
    }

    async initMap() {
      if (!window.google || !google.maps || typeof google.maps.importLibrary !== 'function') {
        this.mapsLoadStarted = false;
        return;
      }

      try {
        const { mapId } = this.mapSettings;
        const ukCenter = { lat: 52.5, lng: -1.5 };

        // loading=async requires importLibrary for Map, Geocoder, etc.
        const [mapsLib, geocodingLib, routesLib, markerLib, placesLib] = await Promise.all([
          google.maps.importLibrary('maps'),
          google.maps.importLibrary('geocoding'),
          google.maps.importLibrary('routes'),
          google.maps.importLibrary('marker'),
          this.autoCompleteEnabled
            ? google.maps.importLibrary('places')
            : Promise.resolve(null),
        ]);
        await google.maps.importLibrary('geometry');

        this.map = new mapsLib.Map(this.DOM.mapEl, {
          center: ukCenter,
          zoom: 7,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          mapId,
        });
        this.geocoder = new geocodingLib.Geocoder();
        this.Route = routesLib.Route;
        this.RouteMatrix = routesLib.RouteMatrix;
        this.AdvancedMarkerElement = markerLib.AdvancedMarkerElement;
        this.PlaceAutocompleteElement = placesLib
          ? placesLib.PlaceAutocompleteElement
          : null;

        this.initPlacesAutocomplete();
        // Don't fit all dealers yet — geolocation (or start point) will set the view.
        // Fitting first would briefly show every pin, then leave that view if the
        // user blocks location and no startLat/startLng is configured.
        this.placeMarkers(this.visibleDealers, false);
        this.tryAutoGeolocation();
        this.refreshMapLayout();
      } catch (err) {
        this.mapsLoadStarted = false;
        this.setStatus('Map could not be loaded. Please refresh and try again.');
        console.error('DealerSearch initMap failed', err);
      }
    }

    refreshMapLayout() {
      if (!this.map) return;

      const center = this.map.getCenter();
      google.maps.event.trigger(this.map, 'resize');
      if (center) {
        this.map.setCenter(center);
      }
    }

    scrollToMapOnMobile() {
      if (!this.DOM.mapWrap || window.innerWidth > DEALER_SEARCH_STACK_MAX) return;

      const offsetY = window.innerWidth <= SCREEN_SM_MAX ? 70 : HEADER_HEIGHT;

      gsap.to(window, {
        duration: 0.8,
        scrollTo: this.DOM.mapWrap.getBoundingClientRect().top + window.scrollY - offsetY,
        onComplete: () => this.refreshMapLayout(),
      });
    }

    tryAutoGeolocation() {
      if (!this.useGeolocationEnabled) {
        this.applyStartPointView();
        return;
      }

      const query = (this.DOM.locationInput ? this.DOM.locationInput.value : '').trim();
      if (query) {
        this.applyStartPointView();
        return;
      }

      this.requestUserLocation(true);
    }

    requestUserLocation(runSearch = true) {
      if (!navigator.geolocation) {
        this.setStatus('Location is not available in this browser.');
        this.placeMarkers(this.visibleDealers, true);
        return;
      }

      this.setStatus('Finding your location…');
      if (this.DOM.locateBtn) this.DOM.locateBtn.disabled = true;

      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (this.DOM.locateBtn) this.DOM.locateBtn.disabled = false;
          this.applyGeolocationResult(
            position.coords.latitude,
            position.coords.longitude,
            runSearch,
          );
        },
        (error) => {
          if (this.DOM.locateBtn) this.DOM.locateBtn.disabled = false;
          this.handleGeolocationError(error);
          // Denied / failed location: show the full dealer set (initial map state).
          this.placeMarkers(this.visibleDealers, true);
        },
        { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 },
      );
    }

    handleGeolocationError(error) {
      if (error.code === error.PERMISSION_DENIED) {
        this.setStatus('Location access was denied. Enter a postcode or city to search.');
      } else if (error.code === error.TIMEOUT) {
        this.setStatus('Could not detect your location in time. Enter a postcode or city to search.');
      } else {
        this.setStatus('Could not detect your location. Enter a postcode or city to search.');
      }
    }

    applyGeolocationResult(lat, lng, runSearch = true) {
      this.selectedLocation = new google.maps.LatLng(lat, lng);

      const finish = (label) => {
        if (label && this.DOM.locationInput) {
          this.DOM.locationInput.value = label;
        }
        this.setStatus('');
        if (runSearch) {
          this.handleSearch(this.selectedLocation);
        } else if (this.map) {
          this.map.panTo(this.selectedLocation);
          this.map.setZoom(10);
        }
      };

      if (this.geocoder) {
        this.geocoder.geocode({ location: this.selectedLocation, region: 'GB' }, (results, status) => {
          const label = status === 'OK' && results[0]
            ? results[0].formatted_address
            : '';
          finish(label);
        });
      } else {
        finish('');
      }
    }

    initPlacesAutocomplete() {
      if (
        !this.autoCompleteEnabled
        || !this.DOM.locationInput
        || !this.PlaceAutocompleteElement
      ) return;

      const originalInput = this.DOM.locationInput;
      this.placesAutocomplete = new this.PlaceAutocompleteElement({
        includedRegionCodes: ['gb'],
        name: originalInput.name,
        placeholder: originalInput.placeholder,
        value: originalInput.value,
      });
      this.placesAutocomplete.id = originalInput.id;
      this.placesAutocomplete.className = originalInput.className;
      this.placesAutocomplete.description = originalInput.getAttribute('aria-label') || '';
      this.placesAutocomplete.noInputIcon = true;

      originalInput.replaceWith(this.placesAutocomplete);
      this.DOM.locationInput = this.placesAutocomplete;

      this.placesAutocomplete.addEventListener('gmp-select', async (event) => {
        const place = event.placePrediction.toPlace();

        try {
          await place.fetchFields({
            fields: ['formattedAddress', 'location'],
          });
        } catch (err) {
          this.selectedLocation = null;
          this.setStatus('Location details could not be loaded. Please try again.');
          return;
        }

        if (!place.location) {
          this.selectedLocation = null;
          return;
        }

        if (place.formattedAddress) {
          this.DOM.locationInput.value = place.formattedAddress;
        }
        this.selectedLocation = place.location;
        this.handleSearch(this.selectedLocation);
      });

      this.DOM.locationInput.addEventListener('input', () => {
        this.selectedLocation = null;
      });
    }

    applyStartPointView() {
      if (!this.map) return;

      const { startLat, startLng } = this.mapSettings;
      const hasStartPoint = startLat != null && startLng != null;
      const center = hasStartPoint
        ? { lat: startLat, lng: startLng }
        : { lat: 52.5, lng: -1.5 };

      this.map.panTo(center);
      this.map.setZoom(10);
    }

    static markerColor(type) {
      if (type === 'full') return '#B5091F';
      if (type === 'parts-service') return '#848E9A';
      return '#0099B3';
    }

    static buildMarkerContent(dealer) {
      const el = document.createElement('div');
      el.style.width = '18px';
      el.style.height = '18px';
      el.style.borderRadius = '50%';
      el.style.backgroundColor = DealerSearch.markerColor(dealer.type);
      el.style.border = '2px solid #ffffff';
      el.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.4)';
      return el;
    }

    placeMarkers(dealers, fitToDealers = true) {
      this.markers.forEach((m) => { m.map = null; });
      this.markers = [];
      if (!this.map || !this.AdvancedMarkerElement) return;

      dealers.forEach((dealer) => {
        const marker = new this.AdvancedMarkerElement({
          position: { lat: dealer.lat, lng: dealer.lng },
          map: this.map,
          title: dealer.name,
          content: DealerSearch.buildMarkerContent(dealer),
          gmpClickable: true,
          anchorLeft: '-50%',
          anchorTop: '-50%',
        });

        marker.addListener('gmp-click', () => {
          this.showMapPanel(dealer);
          this.highlightItem(dealer.id);
        });

        this.markers.push(marker);
      });

      if (fitToDealers && this.markers.length > 0) {
        const bounds = new google.maps.LatLngBounds();
        dealers.forEach(d => bounds.extend({ lat: d.lat, lng: d.lng }));
        this.map.fitBounds(bounds, 40);
      }
    }

    renderResults(dealers) {
      if (!this.DOM.resultsList) return;
      if (this.DOM.countEl) {
        this.DOM.countEl.textContent = `${dealers.length} Result${dealers.length !== 1 ? 's' : ''}`;
      }

      if (dealers.length === 0) {
        this.DOM.resultsList.innerHTML = '<li class="c-dealer-search__no-results normal">No dealers found in this area. Try increasing the search radius.</li>';
        return;
      }

      this.DOM.resultsList.innerHTML = dealers.map(d => DealerSearch.buildItem(d)).join('');

      this.DOM.resultsList.querySelectorAll('.c-dealer-search__item-toggle').forEach((btn) => {
        btn.addEventListener('click', () => {
          const item = btn.closest('.c-dealer-search__item');
          this.toggleItem(item);
        });
      });

      this.DOM.resultsList.querySelectorAll('.c-dealer-search__btn-route').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const dealerId = btn.dataset.routeId;
          const dealer = this.allDealers.find(d => d.id === dealerId);
          if (dealer) this.showRoute(dealer, btn);
        });
      });
    }

    static formatTravelTime(duration) {
      return (duration || '')
        .replace(/\b(?:hours?|hrs?)\b/gi, 'hr')
        .replace(/\b(?:minutes?|mins?)\b/gi, 'min')
        .toUpperCase();
    }

    static formatTravelDistance(distance, metres) {
      if (distance) {
        return String(distance)
          .replace(/\b(?:miles?)\b/gi, 'mi')
          .toUpperCase();
      }

      if (!Number.isFinite(metres) || metres <= 0) return '';

      const miles = metres * 0.000621371;
      const rounded = Math.round(miles * 10) / 10;
      const label = Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
      return `${label} MI`;
    }

    static formatTravelDistanceLabel(distance, metres) {
      return DealerSearch.formatTravelDistance(distance, metres)
        .replace(/\bMI\b/g, 'MILES');
    }

    static buildItem(dealer) {
      const timeIcon = '<svg class="c-dealer-search__item-time-icon img--16" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M10 0C4.4775 0 0 4.4775 0 10C0 15.5225 4.4775 20 10 20C15.5225 20 20 15.5225 20 10C20 4.4775 15.5225 0 10 0ZM10 2.5C13.2544 2.5 16.0031 4.59625 17.0413 7.5H2.95875C3.99688 4.59625 6.74563 2.5 10 2.5ZM10 11.25C9.30937 11.25 8.75 10.6906 8.75 10C8.75 9.30937 9.30937 8.75 10 8.75C10.6906 8.75 11.25 9.30937 11.25 10C11.25 10.6906 10.6906 11.25 10 11.25ZM2.5 10C5.91563 10 8.68188 13.2913 8.74 17.3731C5.205 16.7675 2.5 13.7037 2.5 10ZM11.26 17.3731C11.3181 13.2913 14.0844 10 17.5 10C17.5 13.7037 14.795 16.7675 11.26 17.3731Z" fill="currentColor"/></svg>';
      const travelTime = DealerSearch.formatTravelTime(dealer.travelTime);
      const travelDistance = dealer.travelDistance || '';
      const timeClass = travelTime ? ' has-time' : '';
      const meta = `<span class="c-dealer-search__item-time${timeClass}"><span class="c-dealer-search__item-time-row"><span class="c-dealer-search__item-distance">${travelDistance}</span>${timeIcon}</span><span class="c-dealer-search__item-time-text">${travelTime}</span></span>`;
      return `
        <li class="c-dealer-search__item" data-dealer-id="${dealer.id}">
          <button class="c-dealer-search__item-toggle" type="button" aria-expanded="false" aria-controls="dealer-body-${dealer.id}">
            <span class="c-dealer-search__item-name">${dealer.name}</span>
            <span class="c-dealer-search__item-meta">${meta}<span class="c-dealer-search__item-arrow" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="none">
                      <path d="M0.5 3.18188C0.223858 3.18188 0 3.40574 0 3.68188C0 3.95803 0.223858 4.18188 0.5 4.18188L0.5 3.68188L0.5 3.18188ZM10.8536 4.03544C11.0488 3.84018 11.0488 3.52359 10.8536 3.32833L7.67157 0.146351C7.47631 -0.0489113 7.15973 -0.0489113 6.96447 0.146351C6.7692 0.341613 6.7692 0.658195 6.96447 0.853458L9.79289 3.68188L6.96447 6.51031C6.7692 6.70557 6.7692 7.02216 6.96447 7.21742C7.15973 7.41268 7.47631 7.41268 7.67157 7.21742L10.8536 4.03544ZM0.5 3.68188L0.5 4.18188L10.5 4.18188V3.68188V3.18188L0.5 3.18188L0.5 3.68188Z"></path>
                      </svg></span></span>
          </button>
          <div class="c-dealer-search__item-body" id="dealer-body-${dealer.id}" hidden>
          <div class="c-dealer-search__item-body-inner d--f jc--sb">
            <address class="c-dealer-search__item-address">${dealer.address.join('<br>')}</address>
            ${dealer.hours ? DealerSearch.buildHours(dealer.hours) : ''}
          </div>
           
            ${dealer.tags && dealer.tags.length ? DealerSearch.buildTags(dealer.tags) : ''}
            ${DealerSearch.buildContact(dealer)}
            ${dealer.excerpt ? `<div class="c-dealer-search__item-excerpt m--b-10"><p class="small">${dealer.excerpt}</p></div>` : ''}
            <div class="c-dealer-search__item-actions d--f m--t-16">
              <a href="${dealer.directions}" target="_blank" rel="noopener noreferrer" class="btn btn--primary btn--outline c-dealer-search__btn-directions">
                <span>Get Directions</span>
                <i class="svg-icon svg-google" aria-hidden="true"></i>
              </a>
              <button type="button" class="btn btn--primary btn--outline c-dealer-search__btn-route" data-route-id="${dealer.id}">
                <span>View Route</span>
                <i class="svg-icon svg-route" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </li>`;
    }

    static buildHours(hours) {
      const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
      const rows = days.map(day => `
        <tr>
          <td class="c-dealer-search__hours-day">${day}</td>
          <td class="c-dealer-search__hours-time">${hours[day] || 'Closed'}</td>
        </tr>`).join('');
      return `<table class="c-dealer-search__hours" aria-label="Opening hours">${rows}</table>`;
    }

    static buildTags(tags) {
      const items = tags.map(tag => `
        <li class="c-dealer-search__tag c-dealer-search__tag--${tag.type}">
          <span class="c-dealer-search__tag-icon" aria-hidden="true"></span>
          <span>${tag.label}</span>
        </li>`).join('');
      return `<ul class="c-dealer-search__tags">${items}</ul>`;
    }

    static buildContact(dealer) {
      const lines = [];
      if (dealer.sales) lines.push(`<div><strong>Sales:</strong> <a href="tel:${dealer.sales}">${dealer.sales}</a></div>`);
      if (dealer.aftersales) lines.push(`<div><strong>Aftersales:</strong> <a href="tel:${dealer.aftersales}">${dealer.aftersales}</a></div>`);
      if (dealer.email) lines.push(`<div><strong>Email:</strong> <a href="mailto:${dealer.email}">${dealer.email}</a></div>`);
      if (dealer.web) lines.push(`<div><strong>Web:</strong> <a href="https://${dealer.web}" target="_blank" rel="noopener noreferrer" class="c-dealer-search__link-web">${dealer.web}</a></div>`);
      return lines.length ? `<div class="c-dealer-search__item-contact">${lines.join('')}</div>` : '';
    }

    toggleItem(item) {
      const body = item.querySelector('.c-dealer-search__item-body');
      const btn = item.querySelector('.c-dealer-search__item-toggle');
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';

      this.DOM.resultsList.querySelectorAll('.c-dealer-search__item').forEach((i) => {
        i.querySelector('.c-dealer-search__item-toggle').setAttribute('aria-expanded', 'false');
        const b = i.querySelector('.c-dealer-search__item-body');
        if (b) b.hidden = true;
        i.classList.remove('is-active');
      });

      if (!isExpanded) {
        btn.setAttribute('aria-expanded', 'true');
        if (body) body.hidden = false;
        item.classList.add('is-active');

        const { dealerId } = item.dataset;
        const dealer = this.allDealers.find(d => d.id === dealerId);
        if (dealer && this.map) {
          this.map.panTo({ lat: dealer.lat, lng: dealer.lng });
          this.map.setZoom(12);
          if (window.innerWidth > DEALER_SEARCH_STACK_MAX) {
            this.showMapPanel(dealer);
          }
        }
      }
    }

    highlightItem(dealerId) {
      const item = this.DOM.resultsList.querySelector(`[data-dealer-id="${dealerId}"]`);
      if (item) {
        this.toggleItem(item);
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    showMapPanel(dealer) {
      if (!this.DOM.mapPanel || !this.DOM.mapPanelBody) return;
      this.DOM.mapPanelBody.innerHTML = `
        <h2 class="c-dealer-search__map-panel-name">${dealer.name}</h2>
        ${dealer.tags && dealer.tags.length ? DealerSearch.buildTags(dealer.tags) : ''}
        <div class="c-dealer-search__map-panel-body-inner d--f jc--sb">
        <address class="c-dealer-search__map-panel-address">${dealer.address.join('<br>')}</address>
        ${dealer.hours ? DealerSearch.buildHours(dealer.hours) : ''}
        </div>
        <div class="c-dealer-search__map-panel-contact">
          ${dealer.excerpt ? `<div class="c-dealer-search__map-panel-excerpt m--b-10"><p class="small">${dealer.excerpt}</p></div>` : ''}
          ${dealer.sales ? `<p><strong>Sales:</strong> <a href="tel:${dealer.sales}">${dealer.sales}</a></p>` : ''}
          ${dealer.aftersales ? `<p><strong>Aftersales:</strong> <a href="tel:${dealer.aftersales}">${dealer.aftersales}</a></p>` : ''}
          ${dealer.email ? `<p><strong>Email:</strong> <a href="mailto:${dealer.email}">${dealer.email}</a></p>` : ''}
        </div>
        <a href="${dealer.directions}" target="_blank" rel="noopener noreferrer" class="btn btn--primary btn--outline c-dealer-search__btn-directions">
          <span>Get Directions</span>
          <i class="svg-icon svg-google" aria-hidden="true"></i>
        </a>`;
      this.DOM.mapPanel.hidden = false;
    }

    hideMapPanel() {
      if (this.DOM.mapPanel) {
        this.DOM.mapPanel.hidden = true;
      }
    }

    cancelRouteAnimation() {
      if (this.routeAnimationFrame !== null) {
        window.cancelAnimationFrame(this.routeAnimationFrame);
        this.routeAnimationFrame = null;
      }
    }

    drawAnimatedRoute(path) {
      this.cancelRouteAnimation();

      const polyline = new google.maps.Polyline({
        map: this.map,
        path: [],
        strokeColor: '#B5091F',
        strokeWeight: 5,
        strokeOpacity: 0.85,
      });
      this.routePolylines = [polyline];

      const reducedMotion = window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!this.routeAnimationEnabled || reducedMotion || path.length < 2) {
        polyline.setPath(path);
        return;
      }

      const cumulativeDistances = [0];
      for (let i = 1; i < path.length; i += 1) {
        const segmentLength = google.maps.geometry.spherical.computeDistanceBetween(
          path[i - 1],
          path[i],
        );
        cumulativeDistances.push(cumulativeDistances[i - 1] + segmentLength);
      }

      const totalDistance = cumulativeDistances[cumulativeDistances.length - 1];
      if (!totalDistance) {
        polyline.setPath(path);
        return;
      }

      const animationDuration = 1800;
      const animationStart = window.performance.now();
      const visiblePath = polyline.getPath();
      let revealedIndex = 0;
      let hasInterpolatedPoint = false;
      visiblePath.push(path[0]);

      const drawFrame = (now) => {
        if (hasInterpolatedPoint) {
          visiblePath.pop();
          hasInterpolatedPoint = false;
        }

        const progress = Math.min((now - animationStart) / animationDuration, 1);
        const distanceToReveal = totalDistance * progress;

        while (
          revealedIndex < path.length - 1
          && cumulativeDistances[revealedIndex + 1] <= distanceToReveal
        ) {
          revealedIndex += 1;
          visiblePath.push(path[revealedIndex]);
        }

        if (progress < 1 && revealedIndex < path.length - 1) {
          const segmentStart = cumulativeDistances[revealedIndex];
          const segmentEnd = cumulativeDistances[revealedIndex + 1];
          const segmentProgress = (distanceToReveal - segmentStart)
            / (segmentEnd - segmentStart);
          const interpolatedPoint = google.maps.geometry.spherical.interpolate(
            path[revealedIndex],
            path[revealedIndex + 1],
            segmentProgress,
          );
          visiblePath.push(interpolatedPoint);
          hasInterpolatedPoint = true;
          this.routeAnimationFrame = window.requestAnimationFrame(drawFrame);
        } else {
          polyline.setPath(path);
          this.routeAnimationFrame = null;
        }
      };

      this.routeAnimationFrame = window.requestAnimationFrame(drawFrame);
    }

    async showRoute(dealer, btn) {
      // Toggle off if this dealer's route is already displayed
      if (this.activeRouteItemId === dealer.id) {
        this.clearRoute();
        return;
      }

      const origin = (this.DOM.locationInput ? this.DOM.locationInput.value : '').trim();

      if (!origin) {
        this.setStatus('Please enter your location above to view a route.');
        return;
      }

      if (!this.Route) {
        this.setStatus('Directions are not available. Please add a Google Maps API key.');
        return;
      }

      // Mark button as loading
      btn.disabled = true;
      btn.querySelector('span').textContent = 'Loading\u2026';

      try {
        const { routes } = await this.Route.computeRoutes({
          origin,
          destination: { lat: dealer.lat, lng: dealer.lng },
          travelMode: 'DRIVING',
          units: google.maps.UnitSystem.IMPERIAL,
          region: 'GB',
          computeAlternativeRoutes: false,
          fields: ['localizedValues', 'path'],
        });

        btn.disabled = false;

        if (!routes || routes.length === 0) {
          btn.querySelector('span').textContent = 'View Route';
          this.setStatus('No driving route found between these two locations.');
          return;
        }

        // Reset any previously active View Route button
        if (this.activeRouteItemId) {
          const prevBtn = this.DOM.resultsList.querySelector(`.c-dealer-search__btn-route[data-route-id="${this.activeRouteItemId}"]`);
          if (prevBtn) {
            prevBtn.classList.remove('is-active');
            prevBtn.querySelector('span').textContent = 'View Route';
          }
        }

        // Clear any previously drawn polylines
        this.cancelRouteAnimation();
        this.routePolylines.forEach(p => p.setMap(null));
        this.routePolylines = [];

        // Zoom/pan the map so the whole route is visible in the viewport
        if (this.map && routes[0].path && routes[0].path.length) {
          // Routes returns LatLngAltitude literals, while Polyline and the
          // geometry helpers expect LatLng instances.
          const routePath = routes[0].path.map(point => new google.maps.LatLng(
            typeof point.lat === 'function' ? point.lat() : point.lat,
            typeof point.lng === 'function' ? point.lng() : point.lng,
          ));
          const bounds = new google.maps.LatLngBounds();
          routePath.forEach(point => bounds.extend(point));
          this.map.fitBounds(bounds, 60);
          this.drawAnimatedRoute(routePath);
          this.scrollToMapOnMobile();
        }

        this.activeRouteItemId = dealer.id;

        // Update the button to "Clear Route"
        btn.classList.add('is-active');
        btn.querySelector('span').textContent = 'Clear Route';

        // Hide the map info panel so the route is visible
        this.hideMapPanel();

        // Show a summary in the panel status bar
        const distText = String(routes[0].localizedValues.distance || '')
          .replace(/\b(?:miles?|mi)\b/gi, 'miles');
        const durText = routes[0].localizedValues.duration;
        const ta = document.createElement('textarea');
        ta.innerHTML = dealer.name;
        this.setStatus(`Route to ${ta.value}: ${distText} \u2014 approx. ${durText} driving subject to traffic.`);

        // Sync the item-time badge with the authoritative Directions duration
        dealer.travelTime = DealerSearch.formatTravelTime(durText);
        dealer.travelDistance = DealerSearch.formatTravelDistanceLabel(distText);
        const timeEl = this.DOM.resultsList.querySelector(`[data-dealer-id="${dealer.id}"] .c-dealer-search__item-time`);
        if (timeEl) {
          const textEl = timeEl.querySelector('.c-dealer-search__item-time-text');
          const distanceEl = timeEl.querySelector('.c-dealer-search__item-distance');
          if (textEl) textEl.textContent = dealer.travelTime;
          if (distanceEl) distanceEl.textContent = dealer.travelDistance;
          timeEl.classList.add('has-time');
        }
      } catch (err) {
        btn.disabled = false;
        btn.querySelector('span').textContent = 'View Route';
        this.setStatus('Could not calculate route. Please try again.');
      }
    }

    clearRoute() {
      this.cancelRouteAnimation();

      // Remove rendered route polylines from the map
      this.routePolylines.forEach(p => p.setMap(null));
      this.routePolylines = [];

      // Reset the active button
      if (this.activeRouteItemId) {
        const activeBtn = this.DOM.resultsList.querySelector(`.c-dealer-search__btn-route[data-route-id="${this.activeRouteItemId}"]`);
        if (activeBtn) {
          activeBtn.classList.remove('is-active');
          activeBtn.querySelector('span').textContent = 'View Route';
        }

        // Re-fit the map back to the visible dealer markers now that the route is gone
        if (this.map && this.markers.length) {
          const bounds = new google.maps.LatLngBounds();
          this.markers.forEach(m => bounds.extend(m.position));
          this.map.fitBounds(bounds, 40);
        }
      }

      this.activeRouteItemId = null;
      this.setStatus('');
    }

    async fetchTravelTimes(origin, dealers, radiusMiles) {
      if (!this.RouteMatrix || !dealers.length) return;

      // Show the loading animation in every time slot immediately
      dealers.forEach((dealer) => {
        dealer.travelDurationMillis = null;
        dealer.travelDistanceMeters = null;
        dealer.travelDistance = '';
        const timeEl = this.DOM.resultsList.querySelector(`[data-dealer-id="${dealer.id}"] .c-dealer-search__item-time`);
        if (timeEl) timeEl.classList.add('is-loading');
      });

      // RouteMatrix supports up to 625 elements per request (origins × destinations).
      // Batch at 25 destinations to stay well within limits and keep response times fast.
      const BATCH = 25;
      const batches = [];
      for (let i = 0; i < dealers.length; i += BATCH) {
        batches.push(dealers.slice(i, i + BATCH));
      }

      await Promise.all(batches.map(async (batch) => {
        try {
          const { matrix } = await this.RouteMatrix.computeRouteMatrix({
            origins: [origin],
            destinations: batch.map(d => ({ lat: d.lat, lng: d.lng })),
            travelMode: 'DRIVING',
            units: google.maps.UnitSystem.IMPERIAL,
            region: 'GB',
            fields: [
              'localizedValues',
              'condition',
              'durationMillis',
              'distanceMeters',
            ],
          });

          // matrix.rows[0] corresponds to our single origin; items map 1:1 to destinations
          const elements = (matrix.rows && matrix.rows[0] && matrix.rows[0].items) || [];
          elements.forEach((el, idx) => {
            const dealer = batch[idx];
            const ok = el.condition === 'ROUTE_EXISTS' && el.localizedValues;
            const label = ok
              ? DealerSearch.formatTravelTime(el.localizedValues.duration)
              : '';

            dealer.travelTime = label;
            dealer.travelDurationMillis = ok && Number.isFinite(el.durationMillis)
              ? el.durationMillis
              : null;
            dealer.travelDistanceMeters = ok && Number.isFinite(el.distanceMeters)
              ? el.distanceMeters
              : null;
            dealer.travelDistance = ok
              ? DealerSearch.formatTravelDistanceLabel(
                el.localizedValues.distance,
                dealer.travelDistanceMeters,
              )
              : '';

            const timeEl = this.DOM.resultsList.querySelector(`[data-dealer-id="${dealer.id}"] .c-dealer-search__item-time`);
            if (!timeEl) return;
            timeEl.classList.remove('is-loading');
            const textEl = timeEl.querySelector('.c-dealer-search__item-time-text');
            const distanceEl = timeEl.querySelector('.c-dealer-search__item-distance');
            if (textEl) textEl.textContent = label;
            if (distanceEl) distanceEl.textContent = dealer.travelDistance;
            timeEl.classList.toggle('has-time', !!label);
          });
        } catch (err) {
          // On error clear loading state silently — times are non-critical
          batch.forEach((dealer) => {
            const timeEl = this.DOM.resultsList.querySelector(`[data-dealer-id="${dealer.id}"] .c-dealer-search__item-time`);
            if (timeEl) timeEl.classList.remove('is-loading');
          });
        }
      }));

      this.filterAndSortByTravelMetrics(dealers, radiusMiles);
    }

    // Applies the selected radius using actual road distance, then orders the
    // remaining dealers by shortest driving distance.
    filterAndSortByTravelMetrics(dealers, radiusMiles) {
      if (dealers !== this.visibleDealers) return;

      const radiusMeters = radiusMiles * 1609.344;
      this.visibleDealers = dealers
        .filter(dealer => (
          dealer.travelDistanceMeters != null
          && dealer.travelDistanceMeters <= radiusMeters
          && dealer.travelDurationMillis != null
        ))
        .sort((a, b) => a.travelDistanceMeters - b.travelDistanceMeters);

      this.renderResults(this.visibleDealers);
      this.placeMarkers(this.visibleDealers, false);
    }

    isMapsSearchAvailable() {
      if (typeof window.Cookiebot === 'undefined') return true;
      return DealerSearch.hasMarketingConsent() === true;
    }

    renderCookieBlockedResults() {
      if (!this.DOM.resultsList) return;
      if (this.DOM.countEl) {
        this.DOM.countEl.textContent = '0 Results';
      }
      // this.DOM.resultsList.innerHTML = '<li class="c-dealer-search__no-results normal">Accept cookies to search for dealers by postcode or city.</li>';
    }

    handleSearch(selectedOrigin = null) {
      const query = (this.DOM.locationInput ? this.DOM.locationInput.value : '').trim();
      const radius = parseInt(this.DOM.radiusSelect ? this.DOM.radiusSelect.value : '50', 10);

      this.clearRoute();
      this.setStatus('');

      // Times belong to the previous origin, so drop them before rendering again
      this.allDealers.forEach((dealer) => {
        dealer.travelTime = '';
        dealer.travelDistance = '';
        dealer.travelDurationMillis = null;
        dealer.travelDistanceMeters = null;
      });

      if (!query) {
        this.visibleDealers = this.allDealers.slice();
        this.renderResults(this.visibleDealers);
        this.placeMarkers(this.visibleDealers);
        return;
      }

      // Location search needs Google Maps (geocoding / distance). Without marketing
      // consent the map APIs are unavailable — don't show a misleading "no dealers" message.
      if (!this.isMapsSearchAvailable()) {
        this.visibleDealers = [];
        this.renderCookieBlockedResults();
        this.setStatus('Accept cookies to search by postcode or city.');
        this.showMapConsentPlaceholder();
        return;
      }

      if (!this.geocoder && !(selectedOrigin || this.selectedLocation)) {
        this.setStatus('Map is still loading. Please try again in a moment.');
        return;
      }

      const filterFromOrigin = (origin) => {
        this.visibleDealers = this.allDealers.filter((d) => {
          const dist = google.maps.geometry.spherical.computeDistanceBetween(
            origin,
            new google.maps.LatLng(d.lat, d.lng),
          ) / 1609.34;
          return dist <= radius;
        });
        this.renderResults(this.visibleDealers);
        this.placeMarkers(this.visibleDealers);
        this.fetchTravelTimes(origin, this.visibleDealers, radius);
        if (this.map) {
          this.map.panTo(origin);
          this.map.setZoom(10);
        }
      };

      const origin = selectedOrigin || this.selectedLocation;
      if (origin) {
        filterFromOrigin(origin);
      } else if (this.geocoder) {
        this.geocoder.geocode({ address: query, region: 'GB' }, (results, status) => {
          if (status === 'OK') {
            this.selectedLocation = results[0].geometry.location;
            filterFromOrigin(this.selectedLocation);
          } else {
            this.setStatus('Location not found. Please try a different postcode or town.');
          }
        });
      } else {
        this.setStatus('Map is still loading. Please try again in a moment.');
      }
    }

    setStatus(msg) {
      if (this.DOM.panelStatus) this.DOM.panelStatus.textContent = msg;
    }

    initEvents() {
      if (this.DOM.mapPanelClose) {
        this.DOM.mapPanelClose.addEventListener('click', () => this.hideMapPanel());
      }

      if (this.DOM.form) {
        this.DOM.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.handleSearch();
        });
      }

      if (this.DOM.locateBtn) {
        this.DOM.locateBtn.addEventListener('click', () => {
          this.requestUserLocation(true);
        });
      }

      if (this.DOM.radiusSelect) {
        this.DOM.radiusSelect.addEventListener('change', () => {
          if ((this.DOM.locationInput ? this.DOM.locationInput.value : '').trim()) {
            this.handleSearch();
          }
        });
      }

      if (this.DOM.callbackTrigger && this.DOM.callbackPanel) {
        this.DOM.callbackTrigger.addEventListener('click', () => {
          this.DOM.callbackPanel.hidden = false;
          this.DOM.callbackTrigger.setAttribute('aria-expanded', 'true');
        });
      }

      if (this.DOM.callbackClose) {
        this.DOM.callbackClose.addEventListener('click', () => {
          if (this.DOM.callbackPanel) {
            this.DOM.callbackPanel.hidden = true;
            if (this.DOM.callbackTrigger) this.DOM.callbackTrigger.setAttribute('aria-expanded', 'false');
          }
        });
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.hideMapPanel();
          if (this.DOM.callbackPanel && !this.DOM.callbackPanel.hidden) {
            this.DOM.callbackPanel.hidden = true;
            if (this.DOM.callbackTrigger) this.DOM.callbackTrigger.setAttribute('aria-expanded', 'false');
          }
        }
      });

      window.addEventListener('resize', throttle(() => {
        this.refreshMapLayout();
      }, 200));
    }
  }

  function init() {
    if (MOS.isReady) {
      return;
    }
    MOS.isReady = true;

    MOS.sideNav = new SideNav('.c-main-nav[data-menu-style="sidenav"]', '.c-main-nav__wrapper');
    MOS.sideNavMobile = new SideNav('.c-main-nav[data-menu-style-mobile="sidenav--right"]', '.main-header');
    MOS.mainNav = new MainNav('.c-main-nav', '.c-main-nav__wrapper');
    MOS.megaMenu = new MegaMenu();
    MOS.header = new Header('.main-header[data-menu-type="sticky"]');
    if (document.querySelector('[data-dealer-search]')) {
      MOS.dealerSearch = new DealerSearch(document.querySelector('[data-dealer-search]'));
    }

    if (document.querySelector('.c-search-modal')) {
      MOS.searchModal = new SearchModal('.c-search-modal');
    }

    if (document.querySelector('.c-form-popup')) {
      MOS.formPopup = new FormPopup('.c-form-popup');
    }

    if (document.querySelector('.c-search-results__filters')) {
      MOS.searchResultsFilter = new SearchResultsFilter('.c-search-results__filters');
    }

    // Initialize Hero Sticky Nav
    if (document.querySelector('.c-hero-carousel') && document.querySelector('.c-hero-sticky-nav')) {
      MOS.heroStickyNav = new HeroStickyNav('.c-hero-carousel', '.c-hero-sticky-nav');
    }
    MOS.videos = [];
    document.querySelectorAll('.js-video-wrapper').forEach((element) => {
      MOS.videos.push(new Videos(element));
    });

    if (MOS.Util.hasTouchScreen() || winSize.width <= TABLET_LANDSCAPE) {
      MOS.footerMenu = [];
      document.querySelectorAll('.c-accordion-menu--sm').forEach((element) => {
        MOS.footerMenu.push(new AccordionMenu(element));
      });
    }

    if (document.querySelectorAll('.c-accordion-menu:not(.c-accordion-menu--sm)')) {
      MOS.accordionMenu = [];
      document.querySelectorAll('.c-accordion-menu:not(.c-accordion-menu--sm)').forEach((element) => {
        MOS.accordionMenu.push(new AccordionMenu(element));
      });
    }

    if (document.querySelectorAll('.c-tabs[data-tabs]')) {
      MOS.tabs = [];
      document.querySelectorAll('.c-tabs[data-tabs]').forEach((element) => {
        MOS.tabs.push(new Tabs(element));
      });
    }

    if (document.querySelector('.js-carousel-wrapper')) {
      MOS.carousels = [];
      document.querySelectorAll('.js-carousel-wrapper').forEach((element) => {
        MOS.carousels.push(new Carousels(element));
      });
    }
    if (window.location.hash) {
      gsap.delayedCall(1, scrollToId, [window.location.hash]);
    }

    // hijack link with anchors & scroll to
    document.querySelectorAll('a[href^="#"]').forEach((elt) => {
      elt.addEventListener('click', (e) => {
        e.preventDefault();
        const href = e.currentTarget.getAttribute('href');
        if (href !== undefined) {
          const target = href.split('#')[1];
          if (document.getElementById(target) !== null) {
            scrollTo(document.getElementById(target));
          }
        }
      });
    });
  }

  MOS.Util = {
    hasTouchScreen: () => {
      let hasTouch = false;
      if ('ontouchstart' in window) {
        hasTouch = true;
      } else if ('maxTouchPoints' in navigator) {
        hasTouch = navigator.maxTouchPoints >= 1 && navigator.maxTouchPoints <= 10;
      } else if ('msMaxTouchPoints' in navigator) {
        hasTouch = navigator.msMaxTouchPoints > 0;
      } else {
        const mQ = window.matchMedia && matchMedia('(pointer:coarse)');
        if (mQ && mQ.media === '(pointer:coarse)') {
          hasTouch = !!mQ.matches;
        } else if ('orientation' in window) {
          hasTouch = true; // deprecated, but good fallback
        } else {
          // Only as a last resort, fall back to user agent sniffing
          const UA = navigator.userAgent;
          hasTouch = (
            /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
            /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
          );
        }
      }
      return hasTouch;
    },
  };
  document.addEventListener('DOMContentLoaded', () => {
    gsap.registerPlugin(ScrollToPlugin);
    calcWinSize();
    init();
  });
})();
